<template>
  <!-- 商品报溢 -->
  <div>
    <div class="header_box">
      <div>
        <h4>订单号：BY202302210001</h4>
      </div>
      <el-form
        :inline="true"
        :rules="rulesNoe"
        ref="rulesNoeForm"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="进货日期" prop="value1">
              <el-date-picker
                v-model="formInline.value1"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label=" 备 注"  label-width="50px">
              <el-input
                v-model="formInline.remarks"
                placeholder="备注"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-form-item>
            <el-button type="primary" @click="submitForm('rulesNoeForm', 'add')"
              >保存</el-button
            >
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div class="footer_box">
      <div class="handle_box">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd()"
          >新增</el-button
        >
      </div>
      <el-table
        :data="formInline.goodsJson"
        border
        style="width: 100%"
        height="calc(70vh - 68px)"
      >
        <el-table-column prop="goodsCode" align="center" label="商品编码">
        </el-table-column>
        <el-table-column prop="goodsName" align="center" label="商品名称">
        </el-table-column>
        <el-table-column prop="goodsModel" align="center" label="商品型号">
        </el-table-column>
        <el-table-column prop="unitPrice" align="center" label="单价" width="180">
        </el-table-column>
        <el-table-column prop="goodsNumber" align="center" label="数量" width="100">
          <template slot-scope="scope">
            {{ scope.row.goodsNumber }} ({{ scope.row.goodsUnit }})
          </template>
        </el-table-column>
        <!-- <el-table-column prop="goodsUnit" align="center" label="单位" width="100">
        </el-table-column> -->
        <el-table-column prop="address" align="center" label="总金额" width="180">
          <template slot-scope="scope">
            {{ scope.row.goodsNumber * scope.row.unitPrice }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="cz" label="操作" width="100px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="编辑供应商信息"
              placement="top"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-edit"
                @click="goRedact(scope)"
              ></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="light" content="删除数据" placement="top">
              <!--   指派第一个参数 index 暂时无用 赋值为1  -->
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-delete"
                @click="deleteRow(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="进货入库商品选择" width="75%" :visible.sync="outerVisible">
      <!-- 搜索 -->
      <div>
        <el-input
          style="width: 300px; margin-right: 10px"
          prefix-icon="el-icon-edit"
          v-model="goodsName"
          size="mini"
          placeholder="请输入商品名称"
          clearable
        >
        </el-input>
        <span style="margin-right: 10px"></span>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left: 10px"
          size="mini"
          @click="searchButton()"
          >搜索
        </el-button>
      </div>
      <!-- 表格 -->
      <div>
        <el-table
          ref="multipleTable"
          :data="tableDatA"
          tooltip-effect="dark"
          style="width: 100%"
          height="calc(100vh - 365px)"
        >
          <el-table-column type="index" label="编号" width="50"></el-table-column>
          <el-table-column prop="goodsCode" label="商品编码" width="100" align="center">
          </el-table-column>
          <el-table-column prop="goodsName" label="商品名称" width="120" align="center">
          </el-table-column>
          <el-table-column
            prop="goodsModel"
            label="商品型号"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsType"
            label="商品类别"
            align="center"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsUnit"
            label="商品单位"
            align="center"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="inventoryMin"
            label="上次进价"
            width="100"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="manufacturer"
            label="成本价"
            width="100"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="currentInventory"
            label="当前库存"
            align="center"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="cz" label="操作" width="100px">
            <template slot-scope="scope">
              <el-button type="primary" plain @click="handleSelect(scope)"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog width="50%" title="商品信息" :visible.sync="innerVisible" append-to-body>
        <el-card class="box-card">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-form-inline"
            label-position="right"
          >
            <el-form-item label="商品名称" prop="goodsName">
              <el-input v-model="ruleForm.goodsName" disabled></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="商品编号" prop="goodsCode">
                  <el-input v-model="ruleForm.goodsCode" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品类别" prop="goodsType">
                  <el-select v-model="ruleForm.goodsType" placeholder="请选择" disabled>
                    <el-option
                      v-for="(item, i) in procedureType"
                      :key="i"
                      :label="item.provinceName"
                      :value="item.provinceCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="商品型号" prop="goodsModel">
                  <el-input v-model="ruleForm.goodsModel" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="商品单位" prop="goodsUnit">
                  <el-select v-model="ruleForm.goodsUnit" placeholder="请选择" disabled>
                    <el-option
                      v-for="(item, i) in procedureType"
                      :key="i"
                      :label="item.provinceName"
                      :value="item.provinceCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="上次进价" prop="inventoryMin">
                  <el-input v-model="ruleForm.inventoryMin" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="当前库存" prop="currentInventory">
                  <el-input v-model="ruleForm.currentInventory" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="单价" prop="unitPrice">
                  <el-input
                    v-model="ruleForm.unitPrice"
                    oninput="if(value<0)value=0"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="数量" prop="goodsNumber">
                  <el-input
                    v-model="ruleForm.goodsNumber"
                    oninput="if(value<0)value=0"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="是否含税" prop="taxInclusive">
                  <el-switch v-model="ruleForm.taxInclusive"> </el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="税率"
                  prop="goodsNumber"
                  v-if="ruleForm.taxInclusive"
                >
                  <el-select v-model="ruleForm.taxRate" placeholder="请选择">
                    <el-option
                      v-for="(item, i) in procedureType"
                      :key="i"
                      :label="item.provinceName"
                      :value="item.provinceCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleConfirm('ruleForm')">选择</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "IncomingStock",

  data() {
    return {
      formInline: {
        name: "",
        amountPayable: "",
        actualPayment: "",
        value1: "",
        remarks: "",
        region: "",
        goodsJson: [],
      },
      goodsName: "",
      ruleForm: {
        goodsName: "",
        goodsModel: "",
        goodsType: "",
        goodsCode: "",
        goodsUnit: "",
        inventoryMin: "",
        currentInventory: "",
        unitPrice: "",
        goodsNumber: "",
        taxInclusive: true,
        taxRate: "",
      },
      procedureType: [
        {
          value: "选项1",
          label: "C007",
        },
        {
          value: "选项2",
          label: "C008",
        },
        {
          value: "选项3",
          label: "C009",
        },
      ],
      tableDatA: [
        {
          goodsCode: "010101",
          goodsName: "王小虎",
          goodsModel: "C70",
          goodsType: "产品",
          goodsUnit: "个",
          inventoryMin: "963.00",
          manufacturer: "556",
          currentInventory: "55",
        },
        {
          goodsCode: "010101",
          goodsName: "王小虎",
          goodsModel: "C70",
          goodsType: "产品",
          goodsUnit: "个",
          inventoryMin: "963.00",
          manufacturer: "556",
          currentInventory: "55",
        },
      ],
      outerVisible: false, //外层弹窗
      innerVisible: false, //内层弹窗

      rulesNoe: {
        name: [{ required: true, message: "请选择供应商名称", trigger: "blur" }],
        amountPayable: [{ required: true, message: "请填写应付金额", trigger: "blur" }],
        actualPayment: [{ required: true, message: "请填写实付金额", trigger: "change" }],
        value1: [{ required: true, message: "请选择进货日期", trigger: "change" }],
        region: [{ required: true, message: "请选择是否付款", trigger: "blur" }],
      },

      rules: {
        goodsName: [{ required: true, message: "请填写供应商名称", trigger: "blur" }],
        goodsModel: [{ required: true, message: "请填写商品型号", trigger: "blur" }],
        goodsType: [{ required: true, message: "请选择商品类别", trigger: "change" }],
        goodsUnit: [{ required: true, message: "请选择商品单位", trigger: "change" }],
        inventoryMin: [
          {
            required: true,
            message: "请输入单价，且为正整数类型",
            trigger: "blur",
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
          },
        ],
        goodsCode: [{ required: true, message: "请填写商品编码", trigger: "blur" }],
        currentInventory: [
          { required: true, message: "请填写当前库存", trigger: "blur" },
        ],
        goodsNumber: [{ required: true, message: "请填写数量", trigger: "blur" }],
        unitPrice: [{ required: true, message: "请填写单价", trigger: "blur" }],
        taxInclusive: [{ required: true, message: "请选择是否含税", trigger: "blur" }],
        taxRate: [{ required: true, message: "请选择税率", trigger: "change" }],
      },
    };
  },

  methods: {
    //新增商品单信息
    handleAdd() {
      this.outerVisible = true;
    },
    //选中的商品
    handleSelect(scope) {
      this.innerVisible = true;
      this.ruleForm = scope.row;
    },
    //选择商品信息
    handleConfirm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$notify({
            title: "操作失败",
            dangerouslyUseHTMLString: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
        this.formInline.goodsJson.push(this.ruleForm);
        this.innerVisible = false;
        this.outerVisible = false;
        //计算总金额
        let sum = 0;
        this.formInline.goodsJson.forEach(function (value, index, array) {
          sum += Number(value.unitPrice) * Number(value.goodsNumber);
        });
        this.formInline.amountPayable = sum;
        this.ruleForm = {};
      });
    },
    //提交新增商品信息
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$notify({
            title: "操作失败",
            dangerouslyUseHTMLString: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
        // let resdata = {};
        // try {
        //   if (this.requestApi) {
        //     resdata = await addSupplier(this.ruleForm);
        //     this.$refs["rulesNoeForm"].resetFields();
        //   } else {
        //     resdata = await updateSupplier(this.ruleForm);
        //   }
        // } catch (e) {
        //   console.error("接口异常");
        // }
        //this.searchButton();
        // this.$notify({
        //   title: resdata ? "成功" : "失败",
        //   dangerouslyUseHTMLString: true,
        //   message: resdata ? resdata.message : "服务器开小差了，请稍后再试",
        //   type: resdata ? "success" : "warning",
        // });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header_box {
  h4 {
    margin: 0 0 8px 0;
  }
  ::v-deep .el-form-item {
    margin-bottom: 10px;
  }
  ::v-deep .el-textarea {
    width: 236px;
  }
}
.footer_box {
  .handle_box {
    margin: 0 0 1vh 0;
  }
}
::v-deep.el-input.is-disabled .el-input__inner {
  color: #545456;
}
::v-deep .el-switch {
  height: 32px;
  line-height: 32px;
}
::v-deep .el-tabs--border-card > .el-tabs__content {
  padding: 0 15px 15px;
}
</style>
